export default function usePromise() {
  let resolver
  return [new Promise((resolve, reject) => { resolver = resolve }), resolver]
}